var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-login-failed-page"},[_vm._v("Something went wrong, please refresh the page.")])}
var staticRenderFns = []

export { render, staticRenderFns }